const en = {
  // Nav
  nav: {
    home: 'Home',
    menu: 'Menu',
    order: 'Order',
    gallery: 'Gallery',
    reviews: 'Reviews',
    reservation: 'Reservation',
    reserve: 'Book a table',
  },

  // Home page
  home: {
    sectionCuisine: 'Our cuisine',
    sectionAtmosphere: 'Atmosphere',
    sectionFormules: 'Our set menus',
    sectionActus: 'News',
    sectionSocial: 'Follow us',
    sectionExceptions: 'Exceptional hours',
    formulesSubtitle: 'Great value for your money',
    actusSubtitle: 'What\'s new?',
    seeGallery: 'View the photo gallery',
    seeFullMenu: 'See the full menu',
    googleRating: '4.1/5 on Google',
    googleRatingValue: '4.1',
    googleReviewsCount: '150 reviews',
    formulesFrom: 'Set menus from EUR15',
    closed: 'Closed',
    burgersCount: 'burgers to choose from',
    callUs: 'Call us',
    directions: 'Directions',

    defaultHeroTitle: 'Your neighbourhood restaurant in Bordeaux',
    defaultHeroSubtitle: 'Simple and generous cuisine, shaded terrace, friendly atmosphere.',
    defaultAboutTitle: 'Simple, fresh and generous',
    defaultAboutText: 'At Cote Terrasse, we prepare sincere cuisine using fresh, seasonal produce.',
    defaultAtmosphereTitle: 'A garden-side terrace',
    defaultAtmosphereText: 'Enjoy our garden-side dining room, a true haven of peace in the heart of Bordeaux.',
    defaultCtaTitle: 'Fancy a visit?',
    defaultCtaText: 'Book your table in a few clicks or come see us directly.',
    defaultBtnReserve: 'Book a table',
    defaultBtnMenu: 'See the menu',
    defaultBtnCall: 'Call us',
    defaultBtnDirections: 'Directions',
  },

  // Reservation
  reservation: {
    sectionLabel: 'Reservation & Contact',
    titleOnline: 'Book your table',
    titlePhone: 'Reserve by phone',
    phoneOnly: 'Phone reservation only',
    phoneDesc: 'To book a table, call us directly. Our team will be happy to welcome you.',
    callNow: 'Call now',
    noPhone: 'Phone number not set. Please contact the administrator.',
    formTitle: 'Reservation request',
    name: 'Name',
    phone: 'Phone',
    email: 'Email',
    date: 'Date',
    time: 'Time',
    guests: 'Guests',
    guestSingular: 'guest',
    guestPlural: 'guests',
    message: 'Message (optional)',
    messagePlaceholder: 'Allergies, special requests...',
    choose: 'Choose',
    namePlaceholder: 'Your name',
    phonePlaceholder: '+33 6 ...',
    emailPlaceholder: 'your@email.com',
    submit: 'Send request',
    sending: 'Sending...',
    success: 'Reservation request sent! We will contact you shortly.',
    errorDate: 'Please select a date',
    errorTime: 'Please select a time',
    errorGeneric: 'An error occurred. Please try again.',
    infoTitle: 'Practical information',
    openingHours: 'Opening hours',
    closed: 'Closed',
  },

  // Gallery
  gallery: {
    sectionLabel: 'Gallery',
    title: 'In pictures',
    description: 'Discover our terrace, our garden-side dining room and our dishes in photos.',
    all: 'All',
    plats: 'Dishes',
    terrasse: 'Terrace',
    salle: 'Dining room',
    ambiance: 'Ambiance',
    empty: 'No photos in this category.',
    lightboxTitle: 'Gallery photo',
  },

  // Menu
  menu: {
    sectionLabel: 'Our menu',
    title: 'The Menu',
    description: 'Discover our homemade burgers, sharing tapas, and great value set menus. Cuisine prepared with fresh, seasonal produce.',
    formules: 'Set Menus',
    supplements: 'Add-ons:',
    from: 'from',
    sides: 'Sides',
    sidesIncluded: 'Included with every burger:',
    sidesIncludedText: 'Fresh fries or seasonal salad.',
    sidesSupplements: 'Add-ons:',
    sidesSupplementsText: 'Sweet potato fries +EUR3 | Bacon +EUR3 | Cheddar +EUR2',
    sidesNote: 'ANGUS Steak 100% Pure Beef French Origin 150g — Fresh Fries cooked Belgian-style in Beef Tallow — Duck Breast from South-West France',
  },

  // Reviews
  reviews: {
    sectionLabel: 'Customer reviews',
    title: 'What they think',
    description: 'Mostly 4 and 5-star reviews. Our customers appreciate the quality of our cuisine, reasonable prices and friendly atmosphere.',
    outOf: 'Based on 200+ reviews',
  },

  // Legal
  legal: {
    title: 'Legal notice',
    editor: 'Site publisher',
    hosting: 'Hosting',
    ip: 'Intellectual property',
    ipText: 'All content on this site (text, images, logos, photos) is the exclusive property of Cote Terrasse, unless otherwise stated. Any reproduction, even partial, is prohibited without prior authorisation.',
    data: 'Personal data',
    dataText: 'The information collected via the reservation form (name, email, phone) is used solely for processing your reservation request. In accordance with the GDPR, you have the right to access, rectify, limit and delete your personal data.',
    dataTextPhone: 'We do not collect any personal data directly on this website for reservations, as they are made exclusively by phone. In accordance with the GDPR, you have the right to access, rectify, limit and delete your personal data.',
    cookies: 'Cookies',
    cookiesText: 'This site uses only technical cookies necessary for its operation. No advertising or tracking cookies are used.',
    privacy: 'Privacy policy',
    privacyText: 'We are committed to protecting your privacy. Personal data you provide is never shared with third parties. It is kept for a maximum of 12 months.',
    responsibility: 'Disclaimer',
    responsibilityText: 'Cote Terrasse strives to provide information as accurate as possible. Prices and hours shown are subject to change without notice.',
    publishedBy: 'Publishing director',
    phone: 'Phone',
    mediation: 'Consumer mediation',
    alcohol: 'Alcohol licence',
    meatOrigin: 'Meat origin',
  },

  // Cookies banner
  cookies: {
    bannerText: 'Cote Terrasse uses cookies to ensure the proper functioning of its site. You can choose to accept or customize the use of audience measurement cookies.',
    accept: 'Accept all',
    decline: 'Decline',
    customize: 'Customize',
    save: 'Save preferences',
    essentialOnly: 'Essential cookies only',
    title: 'Cookie settings',
    essentialTitle: 'Technical cookies (Required)',
    essentialDesc: 'These cookies are essential for the site to function (admin session, cart). They cannot be disabled.',
    analyticsTitle: 'Analytical cookies (Optional)',
    analyticsDesc: 'These cookies allow us to measure site traffic and improve your browsing experience.',
  },

  // CGV
  cgv: {
    title: 'Terms and Conditions of Sale (CGV)',
    intro: 'These Terms and Conditions of Sale govern orders placed under the Click & Collect service offered by the Cote Terrasse restaurant.',
    article1Title: '1. Purpose',
    article1Text: 'The CGV apply to any order of dishes placed by the Client on the site to be collected at the Cote Terrasse restaurant.',
    article2Title: '2. Order and Obligation to pay',
    article2Text: 'Any order validation on the site implies an obligation to pay on the part of the Client. Payment is made online or upon collection depending on the options offered.',
    article3Title: '3. Right of withdrawal (Exclusion)',
    article3Text: 'In accordance with Article L. 221-28 12° of the French Consumer Code, contracts for the provision of catering services to be provided on a specific date or period do not benefit from the right of withdrawal. The products being perishable and prepared on demand, no validated order can be cancelled or refunded.',
    article4Title: '4. Collection of orders',
    article4Text: 'The Client agrees to collect their order on the day and time slot chosen. Due to the perishable nature of the products, no unclaimed order can be refunded or kept beyond the day of collection.',
    article5Title: '5. Consumer mediation',
    article5Text: 'In case of an unresolved dispute, the Client can contact the appointed consumer mediator. Their contact details are available on the Legal Notice page of the site.',
  },

  // Allergènes
  allergens: {
    title: 'Regulatory Allergens',
    subtitle: 'In accordance with Regulation (EU) No 1169/2011, here is the list of 14 major allergens that may be present in our dishes:',
    notice: 'Our staff remains at your disposal for any details regarding the exact composition of our dishes.',
    names: {
      gluten: 'Gluten',
      crustaceans: 'Crustaceans',
      eggs: 'Eggs',
      fish: 'Fish',
      peanuts: 'Peanuts',
      soybeans: 'Soybeans',
      milk: 'Milk',
      nuts: 'Nuts',
      celery: 'Celery',
      mustard: 'Mustard',
      sesame: 'Sesame seeds',
      sulphites: 'Sulphites',
      lupin: 'Lupin',
      molluscs: 'Molluscs',
    },
    list: {
      gluten: 'Cereals containing gluten (wheat, rye, barley, oats...)',
      crustaceans: 'Crustaceans and products thereof',
      eggs: 'Eggs and products thereof',
      fish: 'Fish and products thereof',
      peanuts: 'Peanuts and products thereof',
      soybeans: 'Soybeans and products thereof',
      milk: 'Milk and products thereof (including lactose)',
      nuts: 'Nuts (almonds, hazelnuts, walnuts, pistachios...)',
      celery: 'Celery and products thereof',
      mustard: 'Mustard and products thereof',
      sesame: 'Sesame seeds and products thereof',
      sulphites: 'Sulphur dioxide and sulphites (in concentrations of more than 10 mg/kg or 10 mg/l)',
      lupin: 'Lupin and products thereof',
      molluscs: 'Molluscs and products thereof',
    }
  },

  // Footer
  footer: {
    description: 'Friendly restaurant in Bordeaux. Seasonal cuisine, homemade burgers and a lovely garden-side terrace.',
    navigation: 'Navigation',
    contact: 'Contact',
    ourMenu: 'Our Menu',
    customerReviews: 'Customer Reviews',
    legalNotice: 'Legal notice',
    legalAndPrivacy: 'Legal notice & Privacy policy',
    admin: 'Administration',
    copyright: 'All rights reserved.',
    defaultAccessTram: 'Access: Tram A (nearby stop)',
    defaultAccessBus: 'Access: Bus 9 (nearby stop)',
    allergenNotice: 'Net prices in Euros including VAT. In accordance with Decree No. 2015-447, allergen information for our dishes is available on request or can be viewed on the Allergens page.',
  },

  // Maintenance
  maintenance: {
    comingSoon: 'We\'ll be back soon',
    defaultMessage: 'Our website is currently being updated. Thank you for your patience.',
    openingHours: 'Opening hours',
    closed: 'Closed',
    copyright: 'All rights reserved.',
  },

  // Common
  common: {
    closed: 'Closed',
    loading: 'Loading...',
  },
};

export default en;
